module.exports = __webpack_public_path__ + "static/media/hotGaget.9182c308.PNG";